import Api from '../components/api/api';
import arrayUtilities from './arrayUtilities';
import stringHelpers from './stringHelpers';

export const allowedVrmEnableDisable = (allowedVrmId, isEnabled, setErrorMessage, setAllowList, organisationId, token) => {
    const key = "isEnabled"
    Api.allowedVrmEnableDisable(
        data => {
            if (data.isError) {
                setErrorMessage(data.errorMessage)
                arrayUtilities.setStateArrayItemProperty(allowedVrmId, key, !isEnabled, setAllowList)
            }
            else {
                arrayUtilities.setStateArrayItemProperty(allowedVrmId, key, isEnabled, setAllowList)
            }
        },
        error => {
            setErrorMessage(error.errorMessage)
            arrayUtilities.setStateArrayItemProperty(allowedVrmId, key, !isEnabled, setAllowList)
        },
        allowedVrmId, isEnabled, organisationId, token
    )
}

export const disallowedVrmEnableDisable = (disallowedVrmId, isEnabled, setErrorMessage, setAllowList, organisationId, token) => {
    const key = "isEnabled"
    Api.disallowedVrmEnableDisable(
        data => {
            if (data.isError) {
                setErrorMessage(data.errorMessage)
                arrayUtilities.setStateArrayItemProperty(disallowedVrmId, key, !isEnabled, setAllowList)
            }
            else {
                arrayUtilities.setStateArrayItemProperty(disallowedVrmId, key, isEnabled, setAllowList)
            }
        },
        error => {
            setErrorMessage(error.errorMessage)
            arrayUtilities.setStateArrayItemProperty(disallowedVrmId, key, !isEnabled, setAllowList)
        },
        disallowedVrmId, isEnabled, organisationId, token
    )
}

export const renderValidity = (item) => {
    let validityDays
    let validityTimes = ""
    let renderedString = ""
    const formatter = new Intl.DateTimeFormat(navigator.language, { weekday: 'long' });
    if (item) {    
        validityDays = Array.from({ length: 7 }, (_, i) => {
            const date = new Date(2025, 0, 6 + i);
            const formattedDay = formatter.format(date)
            if (item[formattedDay.toLowerCase()]) {
                return stringHelpers.abbreviatedDayOfTheWeek(formattedDay)
            }
        }).filter(Boolean)

        if (!stringHelpers.isNullOrEmpty(item.enabledFromTime) && !stringHelpers.isNullOrEmpty(item.enabledToTime)) {
            validityTimes = `${ item.enabledFromTime.slice(0, 5) } - ${ item.enabledToTime.slice(0, 5) }`
        }

        if (!arrayUtilities.isNullOrEmpty(validityDays)) {
            renderedString += validityDays.join(" ")
        }
        if (!arrayUtilities.isNullOrEmpty(validityDays) && !stringHelpers.isNullOrEmpty(validityTimes)) {
            renderedString += `, `
        }
        if (!stringHelpers.isNullOrEmpty(validityTimes)) {
            renderedString += validityTimes
        }
        return renderedString
    }
}